<template>
  <v-dialog title="Generate Newsletter Link" :visible.sync="dialogVisible" :scrollbar="false"
    :width="upload ? '600px' : '1000px'" @closed="onClosed">
    <template v-if="dialogVisible">
      <template v-if="upload">
        <div class="main">
          <el-upload action="" :http-request="customUpload" :on-remove="handleRemove" :on-error="onError"
            :before-upload="beforeUpload" multiple accept=".html,.pdf,.mp4,.pptx">
            <div class="row">
              <el-button size="small" icon="el-icon-plus" type="primary" style="margin-right: 30px;">
                Choose File
              </el-button>
              <div class="box" @click.stop>
                <span style="display: inline-block;margin-right: 10px;"><span class="red">*</span> 文件是否可下载</span>
                <el-radio v-model="isDownload" :label="1">Yes</el-radio>
                <el-radio v-model="isDownload" :label="0">No</el-radio>
              </div>
            </div>
            <div slot="tip" class="el-upload__tip">
              <span>Only html/pdf/mp4/pptx files can be uploaded</span>
              <span class="red"> Total: {{ uploadList.length }} </span>
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onSave"> Submit</el-button>
          <el-button @click="onClosed"> Cancel </el-button>
        </div>
      </template>
      <template v-else>
        <div class="main">
          <div class="el-upload__tip">
            <el-button type="primary" icon="iconfont icon-export" @click="download" :loading="exporting">
              Export
            </el-button>
            <span class="red"> Total: {{ uploadList.length }} </span>
          </div>
          <el-table :data="tableData">
            <el-table-column prop="OriginalName" label="File Name" width="150" />
            <el-table-column prop="FilePath" label="Newsletter Link" />
          </el-table>
        </div>
      </template>
    </template>
  </v-dialog>
</template>
<script>
import downloadjs from 'downloadjs'

export default {
  name: 'UploadDialog',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    maximumSize: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      upload: true,
      exporting: false,
      uploadList: [],
      tableData: [],
      isDownload: 0,
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
    },
  },
  mounted() { },
  computed: {},
  methods: {
    beforeUpload(file) {
      const isVideo = file.type === 'video/mp4'
      if (isVideo) {
        const isLt2M = file.size / 1024 / 1024 < this.maximumSize
        if (!isLt2M) {
          setTimeout(() => {
            this.$notify({
              title: 'Error',
              message: `The ${file.name} video size must not exceed ${this.maximumSize}MB!`,
              type: 'error',
              duration: 0,
            })
          })
        }
        return isLt2M
      }
      return true
    },
    download() {
      this.exporting = true
      this.axios
        .get(`sys/exportNewsLetter`, {
          params: {
            GroupID: this.GroupID,
          },
          responseType: 'blob',
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, 'application/vnd.ms-excel')
          this.exporting = false
        })
        .catch(() => {
          this.exporting = false
        })
    },
    customUpload(fileObject) {
      let formData = new FormData()
      formData.append('file', fileObject.file)
      this.axios
        .post('/sys/uploadNewsLetter', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            let percent =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0
            fileObject.onProgress({ percent: percent })
          },
        })
        .then((res) => {
          if (res.code === 200) {
            this.uploadList.push(res.data)
            fileObject.onSuccess()
          } else {
            fileObject.onError()
          }
        })
        .catch(() => {
          fileObject.onError()
        })
    },
    onError(err, file) {
      this.$notify({
        title: 'Error',
        message: `The ${file.name} File uploading fails`,
        type: 'error',
        duration: 0,
      })
    },
    handleRemove(file) {
      this.uploadList = this.uploadList.filter(
        (item) => item.OriginalName !== file.name
      )
    },
    onClosed() {
      Object.assign(this.$data, this.$options.data())
      this.$emit('update:visible', false)
    },
    onSave() {
      this.axios
        .post('/sys/newsLetterSave', {
          filePaths: this.uploadList,
          isDownload: this.isDownload,
        })
        .then((res) => {
          if (res.code == 200) {
            this.upload = false
            this.tableData = res.data.NewsLetterFiles
            this.GroupID = res.data.GroupId
          } else {
            this.$message({
              type: 'error',
              message: res.msg,
            })
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.main {
  padding: 20px;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
}

::v-deep {
  .el-dialog__body {
    padding: 0 !important;
    display: flex;
    justify-content: center;
  }
}

.el-upload__tip {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.red {
  color: #d52b1e;
}

.dialog-footer {
  text-align: center;
}

.row {
  display: flex;
  align-items: center;

}
</style>
